export const dateRangeInputRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/;

export const RETRY_MVR_TIME_LIMIT = 15 * 60 * 1000;

export const PAGE_SIZE = 20;
